import { proxy, snapshot, useSnapshot } from "@web-monorepo/hooks";
import { NoiseState, initialNoiseState } from ".";

const store = proxy<NoiseState>({ ...initialNoiseState });

export const toolkitNoiseActions = {
  mergeNoise(payload: Partial<NoiseState>) {
    Object.assign(store, payload);
  },

  resetMicrophonePermissionError() {
    store.microphonePermissionErrorName = initialNoiseState.microphonePermissionErrorName;
  },
};

export function useToolkitNoiseStore() {
  return useSnapshot(store);
}

export function getToolkitNoiseState() {
  return snapshot(store);
}

export function resetToolkitNoiseStore() {
  Object.assign(store, initialNoiseState);
}
